import { Chip } from 'react-native-paper'
import {
  ContributionStatus,
  ContributionType,
} from '../../../../generated/graphql'
import { createStyle } from '../../../../contexts/global-styles.provider'
import { useTranslation } from 'react-i18next'
import { Contribution } from '../../perspective/types'

const STATUS_LABELS = {
  [ContributionStatus.Accepted]: 'Accepted',
  [ContributionStatus.Cancelled]: 'Cancelled',
  [ContributionStatus.Censured]: 'Censured',
  [ContributionStatus.Pending]: 'Pending',
  [ContributionStatus.Rejected]: 'Rejected',
} as const

export const ContributionStatusChip = ({
  contribution,
}: {
  contribution: Contribution
}) => {
  const { t } = useTranslation('contributions')
  const styles = useStyles(contribution)
  return (
    <Chip
      mode={'flat'}
      style={styles.statusChip}
      compact
      textStyle={styles.statusChipLabel}
    >
      {t(STATUS_LABELS[contribution.status])}
    </Chip>
  )
}

const useStyles = (contribution: { status: ContributionStatus }) => {
  const hook = createStyle(({ theme }) => {
    const statusColor =
      theme.colors[
        contribution.status.toLowerCase() as
          | 'accepted'
          | 'rejected'
          | 'pending'
          | 'cancelled'
          | 'censured'
      ]

    return {
      statusChip: {
        borderRadius: 20,
        backgroundColor: statusColor,
        padding: 0,
      },
      statusChipLabel: {
        color: 'white',
        fontSize: 12,
        lineHeight: 15,
      },
    }
  })
  return hook()
}
